import Close from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'
import Button from './Button'

const ConfirmDialog = ({
  title,
  children,
  message,
  onSubmit,
  onClose,
  cancelText,
  submitText,
  loading,
  contentProps,
  titleSx,
  actionsSx,
  dialogSx,
  hideCancel = false,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      {...props}
      maxWidth={'md'}
      sx={{
        '& .MuiDialog-paper': {
          padding: '24px 48px',
          maxWidth: 'unset',
        },
        ...dialogSx,
      }}
      onClose={onClose}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          color: theme => theme.palette.primary.main,
          mb: 2,
          ...titleSx,
        }}
      >
        {title}
        <IconButton
          edge="end"
          color="#979797"
          onClick={onClose}
          aria-label="close"
          sx={{
            position: 'absolute',
            right: '24px',
            top: '12px',
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent {...contentProps}>{children}</DialogContent>
      <DialogActions sx={{ alignSelf: 'center', ...actionsSx }}>
        {!hideCancel && (
          <Button
            sx={{ minWidth: '150px', marginRight: '30px' }}
            loading={loading}
            disabled={loading}
            onClick={onClose}
          >
            {cancelText || t('general.cancel')}
          </Button>
        )}
        <Button sx={{ minWidth: '150px' }} loading={loading} disabled={loading} onClick={onSubmit}>
          {submitText || t('general.complete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
